module.exports = __webpack_public_path__ + "img/cricket-category-icon-white.ce425e3d.png";